import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_MEDIA_SERVICE}`
);

const axiosExt = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/ext/${process.env.NEXT_PUBLIC_PREFIX_MEDIA_SERVICE}`
);

const uploadRoundZeroAudioVideo = async ({
  blob,
  mediaType = 'RoundZeroVideo',
}: {
  mediaType?: string;
  blob: Blob | File;
}): Promise<unknown> => {
  try {
    const body = new FormData();
    const fileExt = mediaType == 'RoundZeroVideo' ? 'mp4' : 'mp3';
    if (mediaType == 'RoundZeroVideo') {
      blob = new Blob([blob], {type: 'video/mp4'});
    }
    body.append('mediaType', mediaType);
    body.append('file', blob, `somefile.${fileExt}`);
    const response = await axios.post(`/files`, body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: unknown) {
    throw error;
  }
};

const deleteRoundZeroAudioVideo = async (
  mediaType: string = 'RoundZeroVideo'
): Promise<unknown> => {
  try {
    const params = new URLSearchParams();
    params.append('mediaType', mediaType);

    const response = await axios.post('/remove', params, {
      headers: {'content-type': 'application/x-www-form-urlencoded'},
    });
    return response.data;
  } catch (error: unknown) {
    throw error;
  }
};

const uploadFile = async (body: FormData) => {
  try {
    const response = await axios.post(`/files`, body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getFile = async (mediaTypes: string[]) => {
  try {
    const response = await axios.get(
      `/files?mediaTypes=${mediaTypes?.join(',') ?? ''}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const uploadSocialPic = async (data: any, options: object) => {
  try {
    const response = await axiosExt.post(`/upload`, data, options);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const mediaService = {
  uploadRoundZeroAudioVideo,
  deleteRoundZeroAudioVideo,
  uploadFile,
  getFile,
  uploadSocialPic,
};

export default mediaService;
